window.DASHBOARD_PRINT = {
    options: {},
    init: function (options) {
        _.extend(window.DASHBOARD_PRINT.options, options);
        window.DASHBOARD_PRINT.initRegisterPrintButton();
        window.DASHBOARD_PRINT.initOverrideCtrlP();
        window.DASHBOARD_PRINT.initResetPageAfterPrint();
    },
    initOverrideCtrlP: function(){
        $(document).on('keydown', function(e) {
            if(e.ctrlKey && (e.key == "p" || e.charCode == 16 || e.charCode == 112 || e.keyCode == 80) ){
                e.cancelBubble = true;
                e.preventDefault();
                e.stopImmediatePropagation();
                $('.map-print-container .dropdown-toggle').dropdown('toggle');
                $('.map-print-container .drive-print-button-a3').focus();
            }
        });
    },
    initResetPageAfterPrint: function(){
        // Some browsers support afterprint - so remove the classes after printing if we can.
        window.addEventListener('afterprint', function(event){
            setTimeout(function(){ // This tiemeout is mostly so the tests can see things in time
                window.app.setPrintPageSize(false);
            }, 1000);
        });
    },
    initRegisterPrintButton: function(){
        $('.drive-print-button').on('click', function(e){
            e.preventDefault();
            $this = $(this);
            /*
            * There's a strange bug/behaviour when printing for a second time without reloading
            * the page which I've been unable to fix. So as a workaround - if the print button has
            * been clicked already - we'll auto reload the page with the print param
            * so the print gets triggered. It's not ideal, but it should keep the UX
            * making sense.
            * TODO: Make the print button work twice in a row.
            */
            if ($this.data('has_printed')) {
                var queryParam = new URLSearchParams(document.location.search);
                queryParam.set('print', $this.data('action'));
                // Push the new query param, but replace the encoded commas with regular commas.
                document.location = window.location.pathname + '?' + queryParam.toString().replace('%2C', ',');
                return;
            }
            $this.data('has_printed', true);
            window.app.setPrintPageSize($this.data('action'), 'portrait');
            // Set the map size manually based on the page size. We do this to get it roughly
            // correct because we can't call fitBounds after the PrintPreview has set the exact
            // size. So we have to get it as correct as possible and hope for the best.
            // These numbers were found by trial and error (using Print Preview in Brave).
            // If we start using Portrait mode we will need to calculate values for those.
            $('.col-map-card-stack').css(
                'flex-basis',
                ($this.data('action').toLowerCase() === 'a3') ? '1050px' : '700px'
            );

            window.DASHBOARD_MAP.fitSubdivisionBounds()
                .then(function(){
                    $('.col-map-card-stack').css('flex-basis', '');
                    $('.col-map-card-stack').removeAttr('style');
                    setTimeout(function(){ // This tiemeout is mostly so the tests can see things in time
                        window.print();
                    }, 2000);
                });
        });
    }
}
